import AssignmentDefaultsEditor from '../components/AssignmentDefaultsEditor';
import StatusTaskTemplatesEditor from '../components/StatusTaskTemplatesEditor';

export default function Konfiguration() {
  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-4xl mx-auto px-4 py-6 space-y-6">
        <div className="bg-white rounded-lg shadow">
          <div className="px-6 py-4 border-b">
            <h2 className="text-lg font-semibold text-gray-900">Standard-Zuständigkeiten</h2>
            <p className="text-sm text-gray-500 mt-1">
              Legen Sie pro Datenart fest, wem neue Einträge automatisch zugewiesen werden,
              wenn kein:e Verantwortliche:r angegeben ist.
            </p>
          </div>
          <div className="px-6 py-6">
            <AssignmentDefaultsEditor />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow">
          <div className="px-6 py-4 border-b">
            <h2 className="text-lg font-semibold text-gray-900">Aufgaben-Vorlagen je Status</h2>
            <p className="text-sm text-gray-500 mt-1">
              Vorgeschlagene nächste Aufgaben je Bearbeitungsstand — als Hilfestellung für die Sachbearbeitung.
            </p>
          </div>
          <div className="px-6 py-6">
            <StatusTaskTemplatesEditor />
          </div>
        </div>
      </main>
    </div>
  );
}
